import React from 'react';

import Link from "../Link";

const pages = [
  { n: "Spotlight", l: "spotlight" },
  { n: "MDLCalc", l: "mdl-calc" },
  { n: "Skills", l: "skills" },
  { n: "Logos", l: "logos" },
  { n: "Libraries", l: "libraries" },
  { n: "Gifs", l: "gifs" },
  { n: "Art", l: "art" },
  { n: "Socials", l: "socials" },
  { n: "Contact", l: "contact" },
]

export default function Links(props) {
  return <nav className="mdl-navigation">
    {
      pages.reverse().map((e, i) => <Link link={e.l} name={e.n} key={i} upper={props.upper} />)
    }
  </nav>
}



// WEBPACK FOOTER //
// ./src/Links/Links.js